module.exports = "/_next/static/images/en_3-6bdc130b91ae4337575fb23b3dfa74bf.jpg";